import { createRoot } from 'react-dom/client';
import { markJuiRoot } from '../jui';
import { injectStyles } from '../styles';
import TrackerApp from './TrackerApp';

/** The tracker site page (tracker.jaiora.me): the whole app in `el`; the returned function unmounts it. */
export function mountTracker(el: Element): () => void {
  if (!(el instanceof HTMLElement)) throw new Error('jaioraBugs.mountTracker: нужен элемент страницы');
  injectStyles();
  el.classList.add('jaiora-bugs');
  const unmark = markJuiRoot(el);
  const root = createRoot(el);
  root.render(<TrackerApp />);
  return () => {
    root.unmount();
    unmark();
  };
}
